/**
 * Where one SignalR `getClientUpdate` push goes (`UserSignalrService`): pure, so the harness specs run it without the hub.
 *
 * - `clients`: people or companies changed (`contact` / `company`) - the Clients grids' "Updates available", open drawers
 *   and pickers.
 * - `leadSummary` (Lead Pipeline LP7): only a Living Lead Summary or an AI next action changed - the Pipeline board, the Lead
 *   banner and an open task panel; never the Clients surfaces.
 * - `leadStages` (Lead Pipeline LP9, PER-51): client stage settings changed (ids = stage ids) - the stage list behind every
 *   Lead surface reloads at once; never the Clients surfaces either.
 * - `lostReasons` (configurable lost reasons, story rule 23): the tenant's lost reasons, the require switch or a Lost stage's
 *   default changed (ids = reason ids) - the reason list behind every "Mark lost" picker reloads; never the Clients surfaces.
 * - null: dropped - no payload, another workspace, or this tab's own echo (the tab that saved already shows its change).
 */
export type ClientUpdateRoute = 'clients' | 'leadSummary' | 'leadStages' | 'lostReasons';

/** The members of a `getClientUpdate` payload the route reads (`ClientUpdateSignal` has them all). */
export interface ClientUpdateRouteInput {
    readonly tenantId: number;
    readonly entityType: string;
    readonly originTabId?: string | null;
}

export function routeClientUpdate(
    payload: ClientUpdateRouteInput | null | undefined,
    tenantId: number | null | undefined,
    isFromThisTab: (originTabId: string | null | undefined) => boolean
): ClientUpdateRoute | null {
    if (!payload || tenantId !== payload.tenantId || isFromThisTab(payload.originTabId)) {
        return null;
    }
    switch (payload.entityType) {
        case 'leadSummary':
            return 'leadSummary';
        case 'leadStages':
            return 'leadStages';
        case 'lostReasons':
            return 'lostReasons';
        default:
            return 'clients';
    }
}
